/* TBET PDP v2 — gallery carousel + size selector + variant sync + swatch toggle */
(function () {
  function initSwatchToggle() {
    const toggle = document.querySelector('[data-tbet-swatch-toggle]');
    const grid = document.querySelector('[data-tbet-swatch-grid]');
    if (!toggle || !grid) return;
    const totalCount = grid.querySelectorAll('.pdp-v2__swatch').length;
    const labelEl = toggle.querySelector('[data-tbet-swatch-toggle-label]');

    toggle.addEventListener('click', function () {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      const next = !expanded;
      toggle.setAttribute('aria-expanded', String(next));
      grid.classList.toggle('is-collapsed', !next);
      if (labelEl) {
        labelEl.textContent = next ? 'Show less ↑' : 'View all ' + totalCount + ' →';
      }
    });
  }

  function initCarousel() {
    const gallery = document.querySelector('[id^="pdpV2Gallery-"]');
    if (!gallery) return;
    const slots = gallery.querySelectorAll('.pdp-v2__slot');
    const counter = gallery.querySelector('[data-tbet-counter]');
    const prev = gallery.querySelector('.pdp-v2__nav--prev');
    const next = gallery.querySelector('.pdp-v2__nav--next');
    const total = slots.length;
    if (!total) return;

    let idx = 0;
    function pad(n) { return String(n).padStart(2, '0'); }
    function show(i) {
      idx = (i + total) % total;
      slots.forEach((s, n) => s.classList.toggle('is-active', n === idx));
      if (counter) counter.textContent = pad(idx + 1) + ' / ' + pad(total);
    }
    if (prev) prev.addEventListener('click', () => show(idx - 1));
    if (next) next.addEventListener('click', () => show(idx + 1));
    document.addEventListener('keydown', function (e) {
      if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') return;
      if (e.key === 'ArrowLeft') show(idx - 1);
      if (e.key === 'ArrowRight') show(idx + 1);
    });
  }

  function initSizeSelector() {
    const grid = document.querySelector('[data-tbet-size-grid]');
    if (!grid) return;
    const variantInput = document.querySelector('[data-tbet-variant-id]');
    const cta = document.querySelector('[data-tbet-cta]');
    const ctaPrice = document.querySelector('[data-tbet-cta-price]');
    const priceDisplay = document.querySelector('[data-tbet-price]');

    grid.addEventListener('click', function (e) {
      const btn = e.target.closest('.pdp-v2__size-btn');
      if (!btn) return;
      if (btn.classList.contains('is-soldout') || btn.disabled) return;

      // Set selected state
      grid.querySelectorAll('.pdp-v2__size-btn').forEach(b => b.classList.remove('is-selected'));
      btn.classList.add('is-selected');

      const variantId = btn.getAttribute('data-variant-id');
      if (variantInput && variantId) {
        variantInput.value = variantId;
      }

      // Update URL with variant param so other apps see the change
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url.toString());

      // CTA was in "needs size" state → flip to live ATC
      if (cta) {
        cta.removeAttribute('data-tbet-needs-size');
        const label = cta.querySelector('[data-tbet-cta-label]');

        // If product data is in window, sync price + CTA via that
        if (window.tbetProductData && Array.isArray(window.tbetProductData.variants)) {
          const v = window.tbetProductData.variants.find(x => String(x.id) === String(variantId));
          if (v) {
            const formatted = formatMoney(v.price, window.tbetProductData.moneyFormat || '€{{amount}}');
            if (priceDisplay) priceDisplay.textContent = formatted;
            if (ctaPrice) ctaPrice.textContent = formatted;
            cta.disabled = !v.available;
            if (label) {
              label.innerHTML = v.available
                ? 'In den Warenkorb · <span data-tbet-cta-price>' + formatted + '</span>'
                : 'Sold out';
            }
            return;
          }
        }
        // No product data in window → still flip the label out of "needs size"
        if (label && /Größe wählen|Choose size/i.test(label.textContent)) {
          label.innerHTML = 'In den Warenkorb';
        }
      }
    });

    // CTA click in "needs size" state → scroll to grid + pulse it
    if (cta) {
      cta.addEventListener('click', function (e) {
        if (cta.hasAttribute('data-tbet-needs-size')) {
          e.preventDefault();
          flashSizeGrid(grid);
        }
      });
    }
  }

  function flashSizeGrid(grid) {
    if (!grid) return;
    // Scroll into view (centered)
    try {
      grid.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } catch (e) {
      grid.scrollIntoView();
    }
    grid.classList.remove('tbet-pulse');
    // Force reflow to restart animation
    void grid.offsetWidth;
    grid.classList.add('tbet-pulse');
    setTimeout(function () { grid.classList.remove('tbet-pulse'); }, 1400);
  }
  // Expose for sticky-cta.js
  window.tbetFlashSizeGrid = function () {
    flashSizeGrid(document.querySelector('[data-tbet-size-grid]'));
  };

  function formatMoney(cents, format) {
    // Match Shopify's `money_without_trailing_zeros` filter:
    // €37,50 stays as €37,50 — but €37,00 collapses to €37.
    let value = (cents / 100).toFixed(2);
    if (value.endsWith('.00')) {
      value = value.slice(0, -3);
    }
    value = value.replace('.', ',');
    return format.replace('{{amount}}', value);
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {
    initCarousel();
    initSizeSelector();
    initSwatchToggle();
  });
})();
